import { ReactNode, useEffect } from 'react';
import './PdfPreviewDialog.scss';

/**
 * Renders a PDF from an object URL in a modal. The caller owns fetching the
 * blob; this owns the URL's lifetime and revokes it on unmount.
 */
export function PdfPreviewDialog({
  url,
  title,
  notice,
  footer,
  onClose,
}: {
  url: string;
  title: string;
  /** Optional banner above the frame — e.g. an unsaved-changes warning. */
  notice?: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
}) {
  // Release the object URL when the dialog unmounts
  useEffect(() => () => URL.revokeObjectURL(url), [url]);

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="pdf-preview-title">
      <div className="modal__backdrop" onClick={onClose} />
      <div className="modal__panel pdf-preview-panel">
        <div className="modal__header">
          <h3 id="pdf-preview-title" className="modal__title">
            {title}
          </h3>
          <button className="btn btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="modal__body pdf-preview-body">
          {notice}
          <iframe className="pdf-preview-frame" src={url} title={title} />
          <div className="muted tiny">
            Not rendering?{' '}
            <a href={url} target="_blank" rel="noreferrer">
              Open in a new tab
            </a>
            .
          </div>
        </div>

        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
}
